module.exports = __webpack_public_path__ + "static/media/quote-chris-world-within.9f660d40.png";